

export class UnitDayHourMinuteRequest {
    unit: string;
    date: string;
    hour: number;
    fromMinute: string;
    toMinute: string;
}